// extracted by mini-css-extract-plugin
export default {"mainContainer":"LastStep_mainContainer__0y0fS","textContainer":"LastStep_textContainer__S3UKl","title":"LastStep_title__JMKuw","viewContainer":"LastStep_viewContainer__hSdZ7"};